import calls from '@/backend/api-calls'

const state = () => ({
  storages: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    warehouse_id: null
  }
})

// getters
const getters = {
  ids: state => {
    return state.storages.map(d => d.id);
  }
}

// actions
const actions = {
  getStorages: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.storages.get(parameters)
        .then(resp => {
          commit("setStorages", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addStorage: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.storages.post(data)
        .then(resp => {
          commit("insertStorage", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Storage successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateStorage: ({commit}, { storageId, data }) => {
    return new Promise((resolve, reject) => {
      calls.storage.put(storageId, data).then(
        resp => {
          commit("insertUpdatedStorage", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Storage successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteStorage: ({commit}, storageId) => {
    return new Promise((resolve, reject) => {
      calls.storage.delete(storageId).then(
        resp => {
          commit("removeStorage", storageId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Storage successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addStorageUnit: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.storageUnits.post(data)
        .then(resp => {
          commit("insertStorageUnit", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setStorages(state, data) {
    state.pagination = data.pagination;
    state.storages = data.results;
  },
  insertStorage(state, data) {
    state.storages.push(data);
  },
  insertUpdatedStorage(state, data) {
    state.storages.forEach((storage, i) => {
      if (storage.id == data.id) {
        state.storages.splice(i, 1, data);
      }
    })
  },
  removeStorage(state, storageId) {
    state.storages.forEach((storage, i) => {
      if (storage.id == storageId) {
        state.storages.splice(i, 1);
      }
      const index = state.selected.indexOf(storageId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  insertStorageUnit(state, storageUnit) {
    state.storages.forEach(storage => {
      if (storage.id == storageUnit.storage_id) {
        storage.storage_units.push(storageUnit);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}